import location from "../../asserts/images/Group 1.svg";
import mail from "../../asserts/images/Group 2.svg";
import call from "../../asserts/images/Group 3.svg";

import "./contactinfo.scss";
const Contactinfo = () => {
  return (
    <div>
      <div className="row contact-info">
        <div className="px-0 col-lg-6 col-md-12 left-contact">
          <h1 className="text-center text-lg-start text-md-center">
            Contact <br /> Informartion
          </h1>
          <p>
            <img src={call} />
            <a href="tel:+919597453137" style={{ color: "inherit", textDecoration: "none" }}>+91 9597453137</a> |
            <a href="tel:+917200187832" style={{ color: "inherit", textDecoration: "none" }}> 7200187832</a>
          </p>
          <p>
            <img src={mail} />
            <a href="mailto:pagirndhunn@gmail.com" style={{ color: "inherit", textDecoration: "none" }}>
              pagirndhunn@gmail.com
            </a>
          </p>
          <div className="location d-flex">
            <img src={location} />
            <p>
              No. 186, Thendral Nagar, Abraham Pandithar Nagar, 5th cross, Thanjavur - 613004
            </p>
          </div>
        </div>
        <div className="px-0 col-lg-5 col-md-12 ">
          <form className="row contact-form" action="get">
            <div className="px-0 col-5">
              <label htmlFor="name">
                Full Name<span className="red">*</span>
              </label>
              <input
                placeholder="Enter Full Name"
                type="text"
                id="name"
                required
              />
              <label htmlFor="number">
                Mobile Number<span className="red">*</span>
              </label>
              <input placeholder="+91" type="number" id="number" required />
            </div>
            <div className="px-0 col-5 form-right">
              <label htmlFor="email">
                Email<span className="red">*</span>
              </label>
              <input
                placeholder="Enter Email"
                type="email"
                id="email"
                required
              />
              <label htmlFor="city">
                City<span className="red">*</span>
              </label>
              <input placeholder="Enter City" type="text" id="city" required />
            </div>
            <div className="px-0 col-12">
              <label htmlFor="message">
                Message<span className="red">*</span>
              </label>
              <textarea
                className="msg-box"
                placeholder="Enter Message"
                id="message"
                required
              />
              <button type="submit">Submit Now</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Contactinfo;
